<template>
  <div class="flex">
    <div class="md:flex hidden">
      <div class="flex flex-row gap-16 justify-center" v-if="!itemData.isOdd">
        <Video :author="itemData.author" :title="itemData.title" :video-id="itemData.videoId"></Video>
        <Content class="w-[40%]" :is-odd="itemData.isOdd" :button-icon="itemData.buttonIcon"
                 :button-text="itemData.buttonText" :content-text="itemData.contentText"
                 :content-title="itemData.contentTitle"></Content>
      </div>
      <div class="flex flex-row gap-16 justify-center" v-if="itemData.isOdd">
        <Content class="w-[40%]" :is-odd="itemData.isOdd" :button-icon="itemData.buttonIcon"
                 :button-text="itemData.buttonText" :content-text="itemData.contentText"
                 :content-title="itemData.contentTitle"></Content>
        <Video :author="itemData.author" :title="itemData.title" :video-id="itemData.videoId"></Video>
      </div>
    </div>
    <div class="md:hidden">
      <div class="flex flex-col gap-8 justify-center">
        <Content :is-odd="itemData.isOdd" :button-icon="itemData.buttonIcon"
                 :button-text="itemData.buttonText" :content-text="itemData.contentText"
                 :content-title="itemData.contentTitle"></Content>
        <Video :author="itemData.author" :title="itemData.title" :video-id="itemData.videoId"></Video>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
import Content from "./ItemContent/Content.vue";
import Video from "./ItemContent/Video.vue";

export default {
  components: {Content, Video},
  props: {
    itemData: {
      title: String,
      author: String,
      videoId: String,
      contentTitle: String,
      contentText: String,
      buttonText: String | undefined,
      buttonIcon: String | undefined,
      isOdd: Boolean
    }
  },
  setup() {
  }
};
</script>
